
import { defineComponent } from 'vue'
// import settings from '@/config/default/setting.config'
// import Logo from '@/assets/imgs/logo.png'
export default defineComponent({
    props: {
        collapse: {
            type: Boolean,
            default: true
        }
    },
    setup() {
        // const title = settings.title
        const title = '管理系统----'
        return {
            title,
            // Logo
        }
    }
})
